import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ModalBaseComponent } from 'app/shared/components/base/modal-base/modal-base.component';
import { ModuleService } from 'app/shared/services/module.service';

@Component({
  selector: 'app-module',
  templateUrl: './module.component.html',
  styleUrls: ['./module.component.scss']
})

export class ModuleComponent extends ModalBaseComponent implements OnInit {

  constructor(public moduleService: ModuleService, protected activeModal: NgbActiveModal, protected translateService: TranslateService) {
    super(activeModal);
  }

  ngOnInit() {
    this.initializeObject();
    this.translateService.get(['module.updatedSuccessfullyMessage'])
      .subscribe(translations => {
        this.updatedSuccessfullyMessage = translations['module.updatedSuccessfullyMessage'];
      });
  }

  initializeObject() {
    super.initializeObject();
  }

  onSubmit(form: NgForm) {
    if (form.value.ModuleId) {
      this.moduleService.putModule(form.value.ModuleId, this.currentObject, () => this.handleSubmit(form), this.updatedSuccessfullyMessage);
    }
  }
}
